<span *ngIf="isReady"
      class="btn btn-default"
      ngbTooltip="{{ tooltip }}"
      [placement]="'top'"
      [triggers]="'click'"
      (click)="copy()"
>
    <span class="fas fa-copy" aria-hidden="true"></span>
</span>
